"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.default = void 0;
var _inheritsLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/inheritsLoose"));
var _taggedTemplateLiteralLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteralLoose"));
var _react = _interopRequireWildcard(require("react"));
var _warning = _interopRequireDefault(require("warning"));
var _styled = _interopRequireWildcard(require("../styled"));
var _RadioButton = _interopRequireDefault(require("./RadioButton"));
var _RadioButtonSquare = _interopRequireDefault(require("./RadioButtonSquare"));
var _templateObject, _templateObject2;
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
var deprecations = function deprecations(props) {
  (0, _warning.default)(props.changeHandler == null, '[RadioGroup] `changeHandler` is deprecated. Use `onChange` instead.');
  (0, _warning.default)(props.blurHandler == null, '[RadioGroup] `blurHandler` is deprecated. Use `onBlur` instead.');
};
var RadioGroupWrapper = _styled.default.span(_templateObject || (_templateObject = (0, _taggedTemplateLiteralLoose2.default)(["\n  ", ";\n"])), function (props) {
  return props.type === 'square-fluid' && (0, _styled.css)(_templateObject2 || (_templateObject2 = (0, _taggedTemplateLiteralLoose2.default)(["\n      display: block;\n      width: 100%;\n    "])));
});
var RadioGroup = /*#__PURE__*/function (_Component) {
  (0, _inheritsLoose2.default)(RadioGroup, _Component);
  function RadioGroup() {
    var _this;
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _Component.call.apply(_Component, [this].concat(args)) || this;
    _this.state = {
      value: _this.props.value
    };
    _this.stateUpdated = function (event) {
      if (_this.props.onChange) {
        _this.props.onChange(event);
      } else if (_this.props.changeHandler) {
        _this.props.changeHandler(event);
      }
    };
    _this.selectOption = function (event) {
      event.persist();
      _this.setState({
        value: event.currentTarget.value
      }, function () {
        return _this.stateUpdated(event);
      });
      if (_this.props.onBlur) {
        _this.props.onBlur(event);
      } else if (_this.props.blurHandler) {
        _this.props.blurHandler(event);
      }
    };
    return _this;
  }
  var _proto = RadioGroup.prototype;
  _proto.componentWillMount = function componentWillMount() {
    deprecations(this.props);
  };
  _proto.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    if (nextProps.value !== this.props.value) {
      this.setState({
        value: nextProps.value
      });
    }
    deprecations(nextProps);
  };
  _proto.render = function render() {
    var _this2 = this;
    var _this$props = this.props,
      name = _this$props.name,
      options = _this$props.options,
      type = _this$props.type;
    var value = this.state.value;
    var width = 100 / options.length + "%";
    return /*#__PURE__*/_react.default.createElement(RadioGroupWrapper, {
      type: type
    }, options.map(function (item, index) {
      if (type === 'square' || type === 'square-fluid') {
        return /*#__PURE__*/_react.default.createElement(_RadioButtonSquare.default
        // eslint-disable-next-line react/no-array-index-key
        , {
          key: index,
          name: name,
          value: item.value,
          label: item.label,
          checked: item.value === value,
          onChange: _this2.selectOption,
          width: type === 'square-fluid' ? width : null
        });
      }
      return /*#__PURE__*/_react.default.createElement(_RadioButton.default
      // eslint-disable-next-line react/no-array-index-key
      , {
        key: index,
        name: name,
        value: item.value,
        label: item.label,
        checked: item.value === value,
        onChange: _this2.selectOption
      });
    }));
  };
  return RadioGroup;
}(_react.Component);
RadioGroup.defaultProps = {
  onChange: null,
  onBlur: null,
  changeHandler: null,
  blurHandler: null,
  defaultValue: '',
  value: '',
  type: 'regular'
};
var _default = exports.default = RadioGroup;